export const aboutStats = [
  { label: '入驻网红', value: '12,800+', suffix: '位' },
  { label: '历史爆料', value: '56,000+', suffix: '条' },
  { label: '日活用户', value: '380万+', suffix: '人' },
  { label: '视频库容', value: '180万+', suffix: '个' },
];

export const aboutFeatures = [
  { title: '全网最快', description: '7×24小时实时监控，第一时间推送最新爆料' },
  { title: '匿名爆料', description: '严格保护爆料人隐私，安全可靠的信息通道' },
  { title: 'AI去重', description: '智能算法筛选真实信息，过滤虚假重复内容' },
  { title: '视频实锤', description: '坚持有图有真相，拒绝无证据的凭空猜测' },
];

export const brandIntro = `吃瓜网在线成立于2020年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为广大网友提供最新、最全、最真实的娱乐圈动态和网红资讯。

我们的团队由一群热爱娱乐、追求真相的年轻人组成，秉持"真实、快速、全面"的理念，通过多渠道信息收集和严格的内容审核机制，确保每一条爆料都有据可查。

经过多年发展，吃瓜网已建立起覆盖明星八卦、网红塌房、黑料曝光、综艺内幕等多个垂直领域的全方位内容矩阵，日均服务数百万用户。

我们深知，在信息爆炸的时代，用户需要的是一个可信赖的吃瓜平台。吃瓜网将继续坚守内容品质，为用户提供更有价值的娱乐资讯服务。`;

export const contactInfo = {
  email: 'hello@hn720.cn',
  wechat: 'chiguawang_official',
  weibo: '@吃瓜网在线',
  address: '北京市朝阳区光华路XX号',
};